module.exports = __webpack_public_path__ + "static/story-of-philosophy-c8345e92cecb700753a0451f32dcf88c.jpg";